import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import { GlobeIcon, SparklesIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-orange-50 pt-32" data-id="element-240">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-241">
        <motion.div className="absolute top-20 left-10 w-64 h-64 bg-green-200 rounded-full opacity-20 blur-3xl" animate={{
        scale: [1, 1.2, 1],
        x: [0, 50, 0],
        y: [0, 30, 0]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-242" />
        <motion.div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-200 rounded-full opacity-20 blur-3xl" animate={{
        scale: [1, 1.3, 1],
        x: [0, -50, 0],
        y: [0, -30, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-243" />
      </div>
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-6" data-id="element-245">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-246">
            <SparklesIcon className="text-orange-600" size={32} data-id="element-247" />
            <GlobeIcon className="text-green-600" size={32} data-id="element-248" />
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-slate-900 mb-6" data-id="element-249">
            Empowering Multilingual
            <span className="block text-green-600" data-id="element-250">Excellence</span>
          </h1>
        </motion.div>
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl md:text-2xl text-slate-600 mb-12 max-w-3xl mx-auto" data-id="element-251">
          Master French, English, German, and Spanish with confidence and
          certification success
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-252">
          <Link to="courses" smooth={true} duration={800} className="bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-700 transition-all duration-200 cursor-pointer shadow-lg hover:shadow-xl" data-id="element-253">
            Start Learning
          </Link>
          <a href="https://apprendre.tv5monde.com/fr/exercices/a1-debutant" target="_blank" rel="noopener noreferrer" className="bg-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-700 transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-254">
            Take a Test
          </a>
          <Link to="contact" smooth={true} duration={800} className="bg-white text-slate-800 px-8 py-4 rounded-full text-lg font-semibold hover:bg-slate-100 transition-all duration-200 cursor-pointer border-2 border-slate-200 shadow-lg hover:shadow-xl" data-id="element-255">
            Book Consultation
          </Link>
        </motion.div>
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-16 text-slate-500" data-id="element-256">
          <p className="text-sm mb-2" data-id="element-257">Trusted by 1000+ students worldwide</p>
          <div className="flex items-center justify-center gap-2" data-id="element-258">
            <div className="flex -space-x-2" data-id="element-259">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-orange-400 border-2 border-white" data-id="element-260" />)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}